






















import Enumerable from "linq";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import { SingleSelectableMixin } from "./mixins";

@Component({
  components: {
    InfiniteLoading
  },
})
export default class CustomListBoxSelector extends Mixins(SingleSelectableMixin) {
  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: 50 })
  loadChunkSize: number;

  loadedOptions: any[] = [];
  private chunkedCount: number = 0;
  private infiniteRetryTimer: NodeJS.Timeout = null;

  $refs!: {
    infiniteLoading: InfiniteLoading,
  };

  onInfinite(): void {
    clearTimeout(this.infiniteRetryTimer);
    this.chunkList();
  }

  private chunkList(): void {
    for (let i = this.chunkedCount; i < (this.chunkedCount + this.loadChunkSize); i++) {
      if (i >= this.filteredOptions.length) {
        this.chunkedCount = this.filteredOptions.length;
        this.$refs.infiniteLoading.stateChanger.complete();
        return;
      }
      this.loadedOptions.push(this.filteredOptions[i]);
    }
    this.chunkedCount += this.loadChunkSize;
    this.$refs.infiniteLoading.stateChanger.loaded();
  }

  private resetChunkList(): void {
    this.loadedOptions = [];
    this.chunkedCount = 0;
    if (this.$refs.infiniteLoading) {
      this.$refs.infiniteLoading.stateChanger.reset();
      this.infiniteRetryTimer = setTimeout(this.resetChunkList, 500);
    }
  }

  optionClass(option: any): string {
    return this.areEqual(this.selectedOption, option)
      ? "selected"
      : undefined;
  }

  onClick(option: any): void {
    this.selectedOption = !this.isClearable || !this.areEqual(this.selectedOption, option)
      ? option
      : null;
  }

  @Watch("filteredOptions")
  onFilteredOptionsUpdated(newValue: any[], oldValue: any[]): void {
    this.resetChunkList();

    // 選択状態を更新
    this.selectedOption = Enumerable.from(newValue)
      .firstOrDefault(o => this.areEqual(this.selectedOption, o), null);
  }
}
